/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($, Tc, SCS, debug, doT) {
	'use strict';

	/**
	 * RoamingTariff module implementation.
	 *
	 * @author Danijel Basic
	 * @namespace Tc.Module
	 * @class RoamingTariff
	 * @extends Tc.Module
	 */
	Tc.Module.RoamingTariff = Tc.Module.extend({

		cache : {
			countryListUrl : '/country/list',
			subscriptionsUrl : '/subscription/list/subscription/scat',
			pricesUrl : '/prices/search',
			operatorsUrl : '/operator/list',
			renderAsList : 'DATA',
			SERVICE_CAMEL : 'CAMEL',
			SERVICE_LTE : 'LTE (4G)',
			SERVICE_FIVE : 'FIVE (5G)',
			SERVICE_GPRS : 'GPRS (2G)',
			SERVICE_GSM : 'GSM',
			SERVICE_UMTS : 'UMTS (3G)',
			SERVICE_SMS : 'SMS',
			SERVICE_MMS : 'MMS',
			SERVICE_SMS_IW : 'SMS IW',
			SERVICE_VOICE : 'VOICE',
			SERVICE_DATA : 'DATA',
			SERVICE_INCOMING : 'incoming',
			SERVICE_OUTGOING : 'outgoing',
			SERVICE_OUTGOING_NO_PREPAID : 'outgoingNoPrepaid',
			FREQ_GSM_UMTS : 'GSM_UMTS',
			FREQ_GPRS : 'GPRS',
			FREQ_LTE : 'LTE',
			FREQ_FIVE : 'FIVE',
			FREQ_UMTS : 'UMTS'
		},

		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			var mod = this;
			debug.log('Tc.Module.RoamingTariff > on');

			mod.$countryField = mod.$ctx.find('#roatCountry');
			mod.$subscriptionField = mod.$ctx.find('#roatSubscription');
			mod.$singleSubscriptionField = mod.$ctx.find('.singleSubscription');
			mod.lang = mod.$countryField.data('language');
			mod.isMobile = SCS.utils.isMobilePage();
			mod.$baseUrl = mod.$ctx.data('appurl');
			mod.hideRoamingPartner = mod.$ctx.data('hideroatpartner');
			mod.$pars = mod.$ctx.find('.rt-par-container');
			mod.initFilter();
			callback();
		},

		initFilter: function () {
			this.loadCountries();
			this.loadSubscriptions();

			// attach onClick handler
			var mod = this;
			var $ctx = mod.$ctx;
			$('.primary-button', $ctx).click(function (evt) {
				evt.preventDefault();
				mod.getRoamingTariffs();
			});
		},

		loadCountries: function () {
			var mod = this;

			$.ajax({
				url: mod.$baseUrl + mod.cache.countryListUrl + '/' + mod.lang,
				type: 'post'
			}).done(function (data) {
				mod.renderTemplate(data, 'script.tmpl-roat-country', mod.$countryField, true);
				if (!mod.isMobile) {

					var $allAboInfoIdsContainer = mod.$ctx.find('#allAboInfoIdsContainer');
					if ($allAboInfoIdsContainer.length > 0) {
						var hiddenId = 'hidden_field_id';

						var $hiddenField = mod.$ctx.find('input[type="hidden"]');
						if ($hiddenField.length > 0) {
							hiddenId = $hiddenField.attr('id');
						}
						var expressionsHtml = '';
						for (var i=0; i < data.allAboInfoIds.length; i+=1) {
							expressionsHtml += 'containsWord(&#36;&#123;' + hiddenId + '&#125;, &#39;' + data.allAboInfoIds[i] + '&#39;) <br>';
						}
						$allAboInfoIdsContainer.html(expressionsHtml);
					}

					mod.$countryField.resetSS();
				}
			}).fail(function (jqXHR) {
				debug.log('Tc.Module.RoamingTariff country AJAX error: ' + jqXHR.responseText);
			});
		},

		loadSubscriptions: function () {
			var mod = this,
				subscriptionCategories = mod.$subscriptionField.data('subscription-categories');

			$.ajax({
				url: mod.$baseUrl + mod.cache.subscriptionsUrl + '?' + mod.convertToQueryParam(subscriptionCategories) + '&lang=' + mod.lang,
				type: 'post'
			}).done(function (data) {
				if (data !== null && data.length === 1) {
					mod.$singleSubscriptionField.text(data[0].name);
					mod.$singleSubscriptionField.attr('value', data[0].id);
					mod.$subscriptionField.addClass('hidden');
					mod.$ctx.find('.dropdown-sub .newListSelected').addClass('hidden');
					mod.$singleSubscriptionField.removeClass('hidden');
				} else {
					mod.renderTemplate(data, 'script.tmpl-roat-subscription', mod.$subscriptionField, true);
					mod.$singleSubscriptionField.addClass('hidden');
					mod.$subscriptionField.removeClass('hidden');
					mod.$ctx.find('.dropdown-sub .newListSelected').removeClass('hidden');
					if (!mod.isMobile) {
						mod.$subscriptionField.resetSS();
					}
				}
			}).fail(function (jqXHR) {
				debug.log('Tc.Module.RoamingTariff subscriptions AJAX error: ' + jqXHR.responseText);
			});
		},

		convertToQueryParam: function(sCat) {

			var sCatArr = sCat.split(',');
			var sCatQuery = '';

			if (sCatArr !== null && sCatArr.length > 0) {
				for (var i = 0; i < sCatArr.length; i+=1) {
					var sCat1 = sCatArr[i];
					if (i > 0) {
						sCatQuery += '&';
					}
					sCatQuery += 'subscriptionCategories=';
					sCatQuery += sCat1;
				}
			}
			return sCatQuery;
		},

		getRoamingTariffs: function () {
			var mod = this,
				$ctx = mod.$ctx;

			var countryId = mod.$countryField.val();
			var subscriptionId = mod.$subscriptionField.hasClass('hidden')? mod.$singleSubscriptionField.attr('value'): mod.$subscriptionField.val();
			var language = mod.lang;

			mod.clearData();
			$.ajax({
				url: mod.$baseUrl + mod.cache.pricesUrl + '/' + countryId + '/' + subscriptionId + '/' + language,
				type: 'post'
			}).done(function (data) {
				if(data){
					mod.showAboInfo(data.aboInfoIds);
				}

				if (data && data.countryInfoList && data.countryInfoList.messages) {
					mod.renderTemplate(data, 'script.tmpl-roat-info-messages', '.info-results', false);
				}

				if (!data || !data.serviceTypes || !data.serviceTypes.length) {
					debug.log('Tc.Module.RoamingTariff > getRoamingTariffs', data);
					$ctx.find('.roat-no-prices').removeClass('hidden');
					return false;
				}

				data.services = mod.getAvailableServices(data.serviceTypes);
				data.renderAsList = mod.cache.renderAsList;
				data.country = mod.$countryField.find('option:selected').html();

				debug.log('Tc.Module.RoamingTariff prices:', data);

				mod.renderTemplate(data, 'script.tmpl-roat-results-list', '.roat-prices-list', false);
				mod.renderTemplate(data, 'script.tmpl-roat-results-table', '.roat-prices', false);

				for (var i=0, ii = mod.$pars.length; i < ii; i+=1){
					if (mod.$pars.eq(i).prev().text().length){
						mod.$pars.eq(i).removeClass('hidden');
					}
				}

				SCS.utils.initNewModules($ctx.find('.roat-prices, .info-results'));
				if (!mod.isMobile && !mod.$subscriptionField.hasClass('hidden')) {
					mod.$subscriptionField.resetSS();
				}

				mod.getRoamingOperators();
			}).fail(function (jqXHR) {
				debug.log('Tc.Module.RoamingTariff prices AJAX error: ' + jqXHR.responseText);
			});
		},

		getAvailableServices: function(serviceTypes) {
			var mod = this;

			mod.services = {
				'data' : false,
				'voce' : false,
				'messaging' : false
			};

			for (var i = 0, ii = serviceTypes.length; i < ii; i+=1){
				if (serviceTypes[i].type === mod.cache.SERVICE_DATA){
					mod.services.data = true;
				}
				if (serviceTypes[i].type === mod.cache.SERVICE_VOICE){
					mod.services.voice = true;
				}
				if (serviceTypes[i].type === mod.cache.SERVICE_SMS || serviceTypes[i].type === mod.cache.SERVICE_MMS ){
					mod.services.messaging = true;
				}
			}

			return mod.services;
		},

		clearData: function () {
			var mod = this,
				$ctx = mod.$ctx;

			$ctx.find('.roat-prices, .roat-operators, #messagesContainer').empty();
			$ctx.find('#aboInfoContainer, #noPricesMessage, #noOperatorsMessage, .rt-par-container').addClass('hidden');
		},

		showAboInfo: function (aboInfoIds) {
			var mod = this;

			var $aboInfoContainer = mod.$ctx.find('#aboInfoContainer');
			if ($aboInfoContainer) {
				if (aboInfoIds.length > 0) {
					mod.$ctx.find('input[type="hidden"]').val(aboInfoIds).trigger('change');
					$aboInfoContainer.removeClass('hidden');
				} else {
					$aboInfoContainer.addClass('hidden');
				}
			}
		},

		getRoamingOperators: function () {
			var mod = this,
				$ctx = mod.$ctx;

			var countryId = mod.$countryField.val();

			$.ajax({
				url: mod.$baseUrl + mod.cache.operatorsUrl + '/' +  countryId,
				type: 'post'
			}).done(function (data) {

				data.services = mod.services;

				if (!data || !data.operators || !data.operators.length) {
					debug.log('Tc.Module.RoamingTariff > getRoamingOperators', data);
					$ctx.find('.roat-no-operators').removeClass('hidden');
					return false;
				}
				var hideAsterisk = true;
				for (var i=0, ii = data.operators.length; i < ii; i += 1) {
					if (data.operators[i].services) {
						data.operators[i].rules = mod.setRoamingOperatorRules(data.operators[i].services);
						data.operators[i].frequencies = mod.collectFrequencies(data.operators[i].services);
					}
					hideAsterisk = hideAsterisk && data.operators[i].rules[mod.cache.SERVICE_CAMEL];
				}

				if(!mod.hideRoamingPartner) {
					mod.renderTemplate(data, 'script.tmpl-roat-operators-list', '.roat-operators', false);

					if ($ctx.find('.roat-operators').text().length){
						$ctx.find('.roat-operators').next().removeClass('hidden');
					}

					SCS.utils.initNewModules(mod.$ctx.find('.roat-operators'));
				}

				var $asteriskContainer = mod.$ctx.find('.roaming-partners-footnote');
				if ($asteriskContainer) {
					if (!hideAsterisk) {
						$asteriskContainer.removeClass('hidden');
					} else {
						$asteriskContainer.addClass('hidden');
					}
				}
			}).fail(function (jqXHR) {
				debug.log('Tc.Module.RoamingTariff operators AJAX error: ' + jqXHR.responseText);
			});
		},

		renderTemplate: function (data, tplSelector, containerElem, append) {
			var mod = this,
				$ctx = mod.$ctx;

			if (data) {
				mod.tmplItem = doT.template($ctx.find(tplSelector).html());
				var $html = $(mod.tmplItem(data));
				if (!append) {
					$ctx.find(containerElem).empty();
				}
				$ctx.find(containerElem).append($html);
			}
		},

		setRoamingOperatorRules: function (services) {
			var mod = this,
				rules = [];

			rules[mod.cache.SERVICE_CAMEL] = false;
			rules[mod.cache.SERVICE_LTE] = false;
			rules[mod.cache.SERVICE_FIVE] = false;
			rules[mod.cache.SERVICE_GPRS] = false;
			rules[mod.cache.SERVICE_GSM] = false;
			rules[mod.cache.SERVICE_UMTS] = false;
			rules[mod.cache.SERVICE_SMS] = false;
			rules[mod.cache.SERVICE_MMS] = false;
			rules[mod.cache.SERVICE_SMS_IW] = false;
			rules[mod.cache.SERVICE_INCOMING] = false;
			rules[mod.cache.SERVICE_OUTGOING] = false;
			rules[mod.cache.SERVICE_OUTGOING_NO_PREPAID] = false;

			for (var i = services.length - 1; i >= 0; i -= 1) {
				rules[services[i].name] = services[i].commerciallyOpen;
				if(services[i].name === mod.cache.SERVICE_SMS_IW){
					rules[services[i].name] = services[i].showSmsIw;
				}
			}

			rules[mod.cache.SERVICE_SMS] = rules[mod.cache.SERVICE_INCOMING] = rules[mod.cache.SERVICE_GSM] || rules[mod.cache.SERVICE_UMTS];
			rules[mod.cache.SERVICE_OUTGOING] = rules[mod.cache.SERVICE_INCOMING] && rules[mod.cache.SERVICE_CAMEL];
			rules[mod.cache.SERVICE_OUTGOING_NO_PREPAID] = rules[mod.cache.SERVICE_INCOMING] && !rules[mod.cache.SERVICE_CAMEL];
			rules[mod.cache.SERVICE_MMS] = rules[mod.cache.SERVICE_GPRS] || rules[mod.cache.SERVICE_UMTS] || rules[mod.cache.SERVICE_LTE]|| rules[mod.cache.SERVICE_FIVE];

			return rules;
		},

		collectFrequencies: function (services) {
			var mod = this,
				frequencies = [],
				collectedFrequencies = [];

			for (var i = services.length - 1; i >= 0; i-=1) {
				frequencies[services[i].name] = services[i].frequency;
			}

			var gsm = frequencies[mod.cache.SERVICE_GSM];
			gsm = mod.mergeFrequenciesRemoveDuplicates(gsm);
			gsm = mod.sortFrequencies(gsm);

			// taken from GSM (PORTAL-6298)
			var gprs = frequencies[mod.cache.SERVICE_GSM];
			gprs = mod.mergeFrequenciesRemoveDuplicates(gprs);
			gprs = mod.sortFrequencies(gprs);

			var umts = frequencies[mod.cache.SERVICE_UMTS];
			umts = mod.mergeFrequenciesRemoveDuplicates(umts);
			umts = mod.sortFrequencies(umts);

			var gsmUmts = '';
			if (gsm) {
				gsmUmts += gsm;
				if (umts) {
					gsmUmts += '/';
					gsmUmts += umts;
				}
			}
			gsmUmts = mod.mergeFrequenciesRemoveDuplicates(gsmUmts);
			gsmUmts = mod.sortFrequencies(gsmUmts);

			var lte = frequencies[mod.cache.SERVICE_LTE];
			lte = mod.mergeFrequenciesRemoveDuplicates(lte);
			lte = mod.sortFrequencies(lte);

			var five = frequencies[mod.cache.SERVICE_FIVE];
			five = mod.mergeFrequenciesRemoveDuplicates(five);
			five = mod.sortFrequencies(five);

			collectedFrequencies[mod.cache.FREQ_GSM_UMTS] = gsmUmts;
			collectedFrequencies[mod.cache.FREQ_GPRS] = gprs;
			collectedFrequencies[mod.cache.FREQ_LTE] = lte;
			collectedFrequencies[mod.cache.FREQ_FIVE] = five;
			collectedFrequencies[mod.cache.FREQ_UMTS] = umts;

			return collectedFrequencies;
		},

		mergeFrequenciesRemoveDuplicates: function (freqStr) {
			var newStr = '';
			if (!freqStr) {
				return newStr;
			}
			if (freqStr.indexOf('/') > -1) {
				var parts = freqStr.split('/');
				var newStrArr = [];
				for(var i = 0; i < parts.length; i += 1) {
					var part = parts[i];
					if ($.inArray(part, newStrArr) === -1) {
						newStrArr.push(part);
					}
				}
				newStr = newStrArr.join('/');
			} else {
				newStr = freqStr;
			}
			return newStr;
		},

		sortFrequencies: function (freqStr) {
			var newStr = '';
			if (!freqStr) {
				return newStr;
			}
			if (freqStr.indexOf('/') > -1) {
				var parts = freqStr.split('/');
				var newStrArr = [];
				for(var i = 0; i < parts.length; i += 1) {
					var part = parts[i];
					if (part !== null && part !== '' && !isNaN(part)) {
						newStrArr.push(parseInt(part, 10));
					}
				}
				var sortedFreqArr = newStrArr.sort(function (a,b) { return a - b; });
				newStr = sortedFreqArr.join('/');
			} else {
				newStr = freqStr;
			}
			return newStr;
		}
	});
}(window.Tc.$, window.Tc, window.SCS = window.SCS || {}, window.debug, window.doT));

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.RoamingTariff.js
// module id = 177
// module chunks = 0